// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hiws-title {
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
}

.hiws-card {
  width: 100%;
  max-width: 1105px;
  border-left: 4px solid #2E6EDF;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  box-shadow: 0 2px 4px #00000014;
}

.hiws-card .ant-card-body {
  padding: 20px;
}

.hiws-description {
  text-align: left;

  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0;
  color: #444444;
  opacity: 1;
}

.hiws-skill-title {
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: #212121;
  opacity: 1;
}

.hiws-skill-icon {
  height: 24px;
  width: 24px;
}

.gray-round-icon {
  background: #EEEEEE 0% 0% no-repeat padding-box;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.hiws-skill-name {
  text-align: left;

  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #212121;
  opacity: 1;
  margin-left: 3px;
}

.hiws-test-link {
  text-align: left;
  text-decoration: underline;
  color: #2E6EDF !important;
  cursor: pointer;
}

.hiws-no-test {
  text-align: left;

  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0;
  color: #444444;
}

.hiws-top-margin-2 {
  margin-top: 2px;
}

.hiws-top-margin-8 {
  margin-top: 8px;
}

.hiws-top-margin-12 {
  margin-top: 12px;
}

.hiws-top-margin-24 {
  margin-top: 24px;
}

.hiws-right-margin-24 {
  margin-right: 24px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/HowItWorks/index.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".hiws-title {\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n}\n\n.hiws-card {\n  width: 100%;\n  max-width: 1105px;\n  border-left: 4px solid #2E6EDF;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  box-shadow: 0 2px 4px #00000014;\n}\n\n.hiws-card .ant-card-body {\n  padding: 20px;\n}\n\n.hiws-description {\n  text-align: left;\n\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0;\n  color: #444444;\n  opacity: 1;\n}\n\n.hiws-skill-title {\n  text-align: left;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 19px;\n  color: #212121;\n  opacity: 1;\n}\n\n.hiws-skill-icon {\n  height: 24px;\n  width: 24px;\n}\n\n.gray-round-icon {\n  background: #EEEEEE 0% 0% no-repeat padding-box;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n\n.hiws-skill-name {\n  text-align: left;\n\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0;\n  color: #212121;\n  opacity: 1;\n  margin-left: 3px;\n}\n\n.hiws-test-link {\n  text-align: left;\n  text-decoration: underline;\n  color: #2E6EDF !important;\n  cursor: pointer;\n}\n\n.hiws-no-test {\n  text-align: left;\n\n  font-size: 14px;\n  line-height: 19px;\n  letter-spacing: 0;\n  color: #444444;\n}\n\n.hiws-top-margin-2 {\n  margin-top: 2px;\n}\n\n.hiws-top-margin-8 {\n  margin-top: 8px;\n}\n\n.hiws-top-margin-12 {\n  margin-top: 12px;\n}\n\n.hiws-top-margin-24 {\n  margin-top: 24px;\n}\n\n.hiws-right-margin-24 {\n  margin-right: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
